import { Button, Icons, Input } from '@commenda/kakashi';
import { TParamValue } from '@commenda/types/src/workflow/dsl';
import { getDefaultFieldRefObj } from './helpers';

export const ObjectEditor = ({
  value,
  onChange,
  renderNestedParamValueEditor,
}: {
  value: Record<string, TParamValue>;
  onChange: (v: Record<string, TParamValue>) => void;
  renderNestedParamValueEditor: (
    nestedKey: string,
    nestedValue: TParamValue,
    onChange: (nestedKey: string, nestedValue: TParamValue) => void
  ) => React.ReactNode;
}) => {
  const entries = Object.entries(value);

  const addField = () => {
    const base = 'field';
    let i = 1;
    while (value[`${base}_${i}`] !== undefined) i += 1;
    onChange({ ...value, [`${base}_${i}`]: getDefaultFieldRefObj() });
  };

  const updateKey = (oldKey: string, newKey: string) => {
    if (!newKey || newKey === oldKey) return;
    const { [oldKey]: v, ...rest } = value;
    onChange({ ...rest, [newKey]: v });
  };

  const updateVal = (k: string, v: TParamValue) =>
    onChange({ ...value, [k]: v });

  const remove = (k: string) => {
    const { [k]: omittedKeys, ...rest } = value;
    onChange(rest);
  };

  return (
    <div className="space-y-3">
      {entries.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No keys yet. Add one below.
        </p>
      )}
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-2">
          {entries.map(([k, v], idx) => (
            <div
              key={idx}
              className="border border-border-primary rounded-md p-2"
            >
              <div className="flex items-center justify-between gap-2">
                <Input
                  value={k}
                  onChange={(e) => updateKey(k, e.target.value)}
                />
                <Button onClick={() => remove(k)}>
                  <Icons.Trash01 className="size-4" />
                </Button>
              </div>
              <div className="mt-2">
                {renderNestedParamValueEditor(k, v, updateVal)}
              </div>
            </div>
          ))}
        </div>
        <Button onClick={addField}>
          <Icons.Plus className="size-4 mr-2" /> Add key
        </Button>
      </div>
    </div>
  );
};
